<p-dialog header="Template Setting" [(visible)]="display" [modal]="true" [responsive]="true"
  [style]="{width: '55vw'}">
  <div class="header">
    <h5>Template Information
        <p-inputSwitch class="header-switch" [(ngModel)]="isActive"></p-inputSwitch>
    </h5>
  </div>
  <div class="card">
  </div>
  <p-footer>
    <button type="button" pButton (click)="onClose()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>
